import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from "../../components/menu";
import Footer from "../../components/footer";
import useAuth from "../../hooks/useAuth";

import { useLocation, useNavigate } from "react-router-dom";
import { FullHeart, Heart } from "../../assets/icons/icons";
import { useEffect, useState } from "react";

import { authApi } from "../../services/api/api"

import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import TextEditor from "../../components/textEditor";
import { FastAverageColor } from "fast-average-color";
import { Favorite, FavoriteBorder } from "@mui/icons-material";


export default function Indicacacao({ item }: any) {

    const { user, theme } = useAuth()

    const navigate = useNavigate()

    const data = useLocation()

    const api = authApi()

    const [text, setText] = useState('')
    function hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    // Função para escurecer uma cor hexadecimal
    function darkenHexColor(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;

        let rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    }
    const [gradientColor, setGradientColor] = useState('transparent');

    useEffect(() => {
        const imageUrl = data?.state.img;
        const fac = new FastAverageColor();

        if (imageUrl) {
            fac.getColorAsync(imageUrl)
                .then(color => {
                    const mainColor = color.hex;
                    const darkColor = darkenHexColor(mainColor, -0.3);

                    setGradientColor(`linear-gradient(to bottom, ${mainColor}, ${darkColor})`);

                    // Calcula a luminosidade da cor principal
                    const rgb = hexToRgb(mainColor);
                    if (rgb) {
                        const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b);
                        // Define a cor do texto: branco para cores escuras, preto para cores claras
                    }
                })
                .catch(e => {
                    console.error("Erro ao extrair cores da imagem:", e);
                    setGradientColor('transparent');
                });
        }
    }, [data?.state.img]);

    async function handleIndication() {

        if (text === '') {
            toast.error('Insira um comentário.', { theme: 'dark', toastId: 'errorText' })
            return
        }

        toast.loading('Carregado.', { theme: 'dark', toastId: 'loading' })

        const indication = {
            text: text,
            user_id: user?.id,
            book_id: data.state.id
        }

        const response = await api.setIndication(indication)

        if (response === 200) {

            toast.dismiss('loading')

            navigate('/indicacoes', { state: true })
        } else {
            toast.error('Ocorreu um erro, tente novamente mais tarde.', { theme: 'dark', toastId: 'error500' })
        }

    }



    return (
        <div className={`main w-screen bg-white ${theme}`}>
            <Menu />
            <div className="content w-screen min-h-screen flex justify-center dark:bg-[#061c3f]">
                <div className="w-full max-w-[1780px] px-4 py-6 md:py-10  ">

                    {/* Cabeçalho Compacto */}
                    <div className="flex flex-col gap-1 mb-4">

                        {/* Título com fonte levemente mais fina e espaçada */}

                        <h4 className="text-slate-400 dark:text-slate-500 text-[10px] font-bold uppercase tracking-[0.3em]">

                            Indicação

                        </h4>

                        <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">

                            Compartilhe sua experiência literária.

                        </h2>

                        <div className="w-full h-[1px] bg-gray-100 dark:bg-slate-600 mt-4"></div>



                    </div>

                    {/* Card Principal Compacto */}
                    <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-gray-100 dark:border-white/5 overflow-hidden ">
                        <div className="flex flex-col md:flex-row ">

                            <div
                                className="md:w-[280px] p-6 flex flex-col items-center justify-center relative border-r border-gray-100 dark:border-white/5"
                                style={{ background: gradientColor }}
                            >
                                <div className="absolute top-2 right-2 z-50">
                                    <div className="flex items-center gap-1 px-2 py-1 bg-white/50 backdrop-blur-md rounded-full border border-white/20 shadow-sm transition-all group-hover:bg-white/70">
                                        <span className="text-red-600 flex items-center">
                                            {/* Usando data.state.rating ou item.likes conforme sua lógica de dados */}
                                            {data.state.rating > 0 ? <Favorite sx={{ fontSize: 16 }} /> : <FavoriteBorder sx={{ fontSize: 16 }} />}
                                        </span>
                                        <span className="text-red-600 text-[11px] font-bold">
                                            {data.state.rating}
                                        </span>
                                    </div>
                                </div>
                                <div className="relative group shadow-2xl">

                                    {/* Badge de Curtidas Padronizado (Novo) */}


                                    <img
                                        src={data.state.img}
                                        alt="capa do livro"
                                        className="rounded-lg shadow-lg object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                                        style={{ width: '160px', height: '240px' }}
                                    />


                                </div>


                            </div>

                            {/* Lado Direito: Editor e Detalhes (Aproveitando espaço) */}
                            <div className="flex-1 p-6 md:p-8 flex flex-col gap-5">

                                <div className="flex flex-col md:flex-row md:items-end justify-between gap-2">
                                    <div>
                                        <h3 className="text-2xl font-black text-gray-900 dark:text-white capitalize tracking-tight leading-none">
                                            {data.state.title}
                                        </h3>
                                        <p className="text-sm text-blue3 dark:text-blue5 font-medium mt-1">
                                            {data.state.autor}
                                        </p>
                                    </div>

                                </div>

                                {/* Sinopse em formato de "Quote" */}
                                <div className="relative">
                                    <label className="text-[9px] uppercase font-bold tracking-widest text-gray-400 mb-1 block">Sinopse</label>
                                    <div className="bg-gray-50 dark:bg-white/5 p-4 rounded-xl italic text-gray-600 dark:text-gray-300 text-xs leading-relaxed max-h-96 overflow-y-auto custom-scrollbar">
                                        "{data.state.summary}"
                                    </div>
                                </div>

                                {/* Editor de Texto (Ocupando o restante) */}
                                <div className="flex-1 flex flex-col max-h-64">
                                    <label className="text-[9px] uppercase font-bold tracking-widest text-gray-400 mb-1 block">Seu Comentário</label>
                                    <div className="flex-1 rounded-xl border border-gray-200 dark:border-white/10 overflow-hidden bg-white shadow-inner">
                                        <TextEditor setText={setText} />
                                    </div>
                                </div>

                                {/* Botão de Ação Compacto */}
                                <div className="flex justify-end mt-2">
                                    <button
                                        onClick={handleIndication}
                                        className="w-full md:w-auto px-10 h-11 bg-blue3 hover:bg-blue-600 text-white text-xs font-bold rounded-xl shadow shadow-blue-500/20 transition-all active:scale-95 flex items-center justify-center gap-2 uppercase tracking-widest"
                                    >
                                       Enviar Indicação
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <ToastContainer />
            </div>
        </div>
    )
}